/*
 * Automatically generated by 'ng g ng-alain:plugin icon'
 * @see https://ng-alain.com/cli/plugin#icon
 */

import {
  AccountBookOutline,
  AlignLeftOutline,
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowUpOutline,
  BookOutline,
  CalculatorOutline,
  CaretRightOutline,
  CheckCircleOutline,
  CheckSquareOutline,
  CloudOutline,
  ClusterOutline,
  CodeSandboxOutline,
  CommentOutline,
  ContactsOutline,
  ContainerOutline,
  CopyrightOutline,
  CreditCardOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DeploymentUnitOutline,
  DingdingOutline,
  DislikeOutline,
  DotChartOutline,
  DoubleRightOutline,
  DownloadOutline,
  ExceptionOutline,
  EyeOutline,
  FileAddTwoTone,
  FileDoneOutline,
  FileImageOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileTwoTone,
  FileWordOutline,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  FunctionOutline,
  FunnelPlotOutline,
  GithubOutline,
  GlobalOutline,
  GoldOutline,
  HddOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  MergeCellsOutline,
  MessageOutline,
  MinusCircleOutline,
  NodeIndexOutline,
  OneToOneOutline,
  OrderedListOutline,
  PayCircleOutline,
  PieChartOutline,
  PlusCircleOutline,
  PoundOutline,
  PrinterOutline,
  ProjectOutline,
  PropertySafetyOutline,
  PullRequestOutline,
  PushpinOutline,
  ReloadOutline,
  RetweetOutline,
  RobotOutline,
  RocketOutline,
  RotateLeftOutline,
  RotateRightOutline,
  SafetyCertificateOutline,
  SaveOutline,
  ScanOutline,
  SendOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SisternodeOutline,
  SoundOutline,
  StarOutline,
  SubnodeOutline,
  TableOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrademarkOutline,
  TransactionOutline,
  TrophyOutline,
  UngroupOutline,
  UnlockOutline,
  UnorderedListOutline,
  UsbOutline,
  UsergroupDeleteOutline,
  UserOutline,
  WarningOutline,
  WechatOutline,
  WeiboCircleOutline,
  ZoomInOutline,
  ZoomOutOutline,
  GiftOutline,
  BorderLeftOutline,
  CloseCircleOutline,
  CloudDownloadOutline,
  AreaChartOutline,
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  CloseCircleOutline,
  BorderLeftOutline,
  GiftOutline,
  ArrowUpOutline,
  TableOutline,
  CheckCircleOutline,
  TransactionOutline,
  RetweetOutline,
  WarningOutline,
  FileImageOutline,
  ZoomOutOutline,
  ZoomInOutline,
  RotateRightOutline,
  RotateLeftOutline,
  EyeOutline,
  AlignLeftOutline,
  FilePdfOutline,
  FileTwoTone,
  FileAddTwoTone,
  SubnodeOutline,
  SisternodeOutline,
  FunnelPlotOutline,
  PullRequestOutline,
  NodeIndexOutline,
  MergeCellsOutline,
  SaveOutline,
  FileWordOutline,
  CheckSquareOutline,
  InboxOutline,
  DeploymentUnitOutline,
  GoldOutline,
  ClusterOutline,
  CodeSandboxOutline,
  CalculatorOutline,
  SafetyCertificateOutline,
  UsergroupDeleteOutline,
  IdcardOutline,
  TrademarkOutline,
  ReloadOutline,
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowDownOutline,
  BookOutline,
  CloudOutline,
  CopyrightOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DingdingOutline,
  DislikeOutline,
  DownloadOutline,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GithubOutline,
  GlobalOutline,
  HddOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  PayCircleOutline,
  PieChartOutline,
  PrinterOutline,
  RocketOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SoundOutline,
  StarOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrophyOutline,
  UsbOutline,
  UserOutline,
  WeiboCircleOutline,
  PlusCircleOutline,
  CommentOutline,
  ContactsOutline,
  WechatOutline,
  SendOutline,
  MenuOutline,
  HomeOutline,
  FunctionOutline,
  MinusCircleOutline,
  FileDoneOutline,
  ContainerOutline,
  PropertySafetyOutline,
  FileProtectOutline,
  ProjectOutline,
  UnlockOutline,
  AccountBookOutline,
  UngroupOutline,
  PoundOutline,
  OrderedListOutline,
  UnorderedListOutline,
  CreditCardOutline,
  PushpinOutline,
  OneToOneOutline,
  RobotOutline,
  DoubleRightOutline,
  CaretRightOutline,
  ExceptionOutline,
  DotChartOutline,
  CloudDownloadOutline,
  AreaChartOutline,
];
